/**
 * @file Vue 扩展
 * @author qiaogang
 * @date 2019-08-26
 */
import Vue from 'vue';
import { injectFastClickDirective, injectLogDirective, injectOssImgDirective } from '@igetcool/base-components';

injectFastClickDirective(Vue);
injectLogDirective(Vue);
injectOssImgDirective(Vue);
